import React, { FunctionComponent, useState } from "react";

import style from "./input.module.scss";

interface ITextInput {
  updateUserName: (userName: string) => void;
  label?: string;
  userName: string;
  type?: string;
  name: string;
  disabled?: boolean;
}

export const checkValue = (value: any): boolean => {

  if (value === undefined) return false;

  if (value === null) return false;

  if (typeof value === "string") return value !== "";

  if (typeof value === "boolean") return true;
  return true;
};

export const TextInput: FunctionComponent<ITextInput> = (props) => {

  const {
    userName,
    label = "UserName",
    type = "text",
    name,
    disabled = false,
  } = props;

  const [ isFocused, setFocus] = useState(false);

  const onUserChange = (ev) => {
    const newUser = ev.target.value || "";
    props.updateUserName(newUser);
  };

  const labelUp = checkValue(userName) || isFocused;
  return (<div className={style.wrapper}>
    <p
      className={style.label}
      style={{
        transform: `translateY(${labelUp ? 15 : 45}px)`,
        color: labelUp ? "black" : "darkgray",
      }}
    > {label} </p>
    <input
      type={type}
      name={name}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      onChange={onUserChange}
      value={userName}
      disabled={disabled}
    />

  </div>);
};
